import axios from "axios";
import { API_DOMAIN, Whatsapp_DOMAIN, wati_DOMAIN } from "./constants";

// Attach the auth token to every request aimed at our own backends.
// Individual call sites no longer need to pass the accessToken header
// themselves (existing ones keep working — this only fills the gap).
const OWN_ORIGINS = [API_DOMAIN, Whatsapp_DOMAIN, wati_DOMAIN].filter(Boolean);

axios.interceptors.request.use((config) => {
  const url = config.url || "";
  const isOwn = url.startsWith("/") || OWN_ORIGINS.some((origin) => url.startsWith(origin));
  if (isOwn) {
    const token = localStorage.getItem("accessToken");
    if (token && !config.headers?.accessToken) {
      config.headers = config.headers || {};
      config.headers.accessToken = token;
    }
  }
  return config;
});

// ── Auto-logout on rejected/expired token ────────────────────────────────────
// The backend replies HTTP 200 with { success: false, message: "not logged in" }
// when token verification fails. AuthContext registers the actual logout via
// setOnUnauthorized (this module has no React access).
let onUnauthorized = null;
export const setOnUnauthorized = (fn) => { onUnauthorized = fn; };

let lastUnauthorizedAt = 0;
axios.interceptors.response.use((response) => {
  const url = response.config?.url || "";
  const isOwn = url.startsWith("/") || OWN_ORIGINS.some((origin) => url.startsWith(origin));
  if (
    isOwn &&
    !url.includes("/auth/login") &&
    response.data?.success === false &&
    String(response.data?.message || "").trim().toLowerCase() === "not logged in"
  ) {
    // Parallel calls all fail at once when a session dies — fire logout once
    const now = Date.now();
    if (now - lastUnauthorizedAt > 5000) {
      lastUnauthorizedAt = now;
      onUnauthorized?.();
    }
  }
  return response;
});
